// Third-party
import React, { ReactElement } from 'react';

import { Typography } from '@capintel/component-lib/typography';
import { Button } from '@capintel/component-lib/button';

import LinkReactRouter from './LinkReactRouter';

export type BreadcrumbItem = {
  value: React.ReactNode;
  redirect?: string;
  onClick?: () => void;
};

type Props = {
  items: BreadcrumbItem[];
  replace?: boolean;
};

export default function BreadcrumbNav(props: Props): ReactElement {
  return (
    <div className="breadcrumb-nav">
      {props.items.map((item, index) => {
        return (
          <React.Fragment key={item.value?.toString()}>
            {index > 0 && (
              <div className="breadcrumb-divider">
                <i className="icon-cheveron-right" />
              </div>
            )}

            {item.redirect && (
              <LinkReactRouter to={item.redirect} variant="subtle">
                {item.value}
              </LinkReactRouter>
            )}

            {item.onClick && (
              <Button variant="secondary" appearance="text" onClick={item.onClick}>
                {item.value}
              </Button>
            )}

            {!item.redirect && !item.onClick && (
              <div className="no-link">
                <Typography variant="header2Xs">{item.value}</Typography>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
